import React, { useState, useEffect, useRef } from "react";
import ApiClient from "../services/api-client"
import { AgGridReact } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'
import { CustomConfirmAlert as confirmAlert } from '../components/custom-confirm-alert';
import moment from 'moment-timezone'
import AG_GRID_LOCALE_GR from '../locales/gr/aggrid-translation.js';
import AG_GRID_LOCALE_EN from '../locales/gb/aggrid-translation.js';
import BlockUi from '@availity/block-ui';
import { toast } from 'react-toastify';
import CustomDateComponent from '../components/sales/customDateComponent.js';
import Modal from 'react-bootstrap/Modal';
import Tippy from '@tippyjs/react';
import SelectTable from '../components/select-table'
import { useForm, Controller } from "react-hook-form";
import IFramePrintTemplate from '../components/iframe-print-template.component';
import MyDataLogo from "../img/mydata.png";
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { isMobile } from "react-device-detect";
import useStore from "../hooks/useStore";
import usePrintSaleBuilder from "../hooks/usePrintSaleBuilder";
import DateRangePickerInput from "../components/date-range-picker-input.js";
import AllFieldsRenderer from "../components/aggrids/aggrid-cell-renderers/all-fields-renderer";
import SeriesNumberRendener from "../components/aggrids/aggrid-cell-renderers/seriesnumber-renderer";
import PresalesActionRenderer from "../components/aggrids/aggrid-cell-renderers/presales-action-renderer";

export default function PreSaleSearch() {

    const navigate = useNavigate();
    const [gridApi, setGridApi] = useState(null);
    const { t, i18n } = useTranslation();
    const [printSale, setPrintSale] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [fastFilter, setFastFilter] = useState("");
    const [blockuiLoading, setBlockuiLoading] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const { control, formState: { errors } } = useForm();
    const [customerContacts, setCustomerContacts] = useState([]);
    const [selectedCustomerContacts, setSelectedCustomerContacts] = useState([]);
    const [lineData, setLineData] = useState({});
    const iframePrintTemplate = useRef();
    var to = null;
    const pagination = true;
    const paginationPageSize = 20;
    const [sheight, setSheight] = useState(window.innerHeight - 190);
    const [sendPaymentLink, setSendPaymentLink] = useState(false);
    const [template, setTemplate] = useState(false);
    const [touchStart, setTouchStart] = useState(null)
    const [touchEnd, setTouchEnd] = useState(null)
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [focusedInput, setFocusedInput] = useState();
    const [columnGridApi, setColumnGridApi] = useState(null);

    const minSwipeDistance = 200
    const { buildPrintSale } = usePrintSaleBuilder();

    const [aggridLocal, setAggridLocal] = useState(AG_GRID_LOCALE_GR);
    moment.tz.setDefault('Europe/Athens');


    const onTouchStart = (e) => {
        setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
        setTouchStart(e.targetTouches[0].clientX)
    }

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX)
    }

    const onTouchEnd = () => {
        var currentPage = gridApi.paginationGetCurrentPage();
        var lastpage = gridApi.paginationGetTotalPages();

        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (isLeftSwipe) {
            if (currentPage != lastpage) {
                gridApi.paginationGoToPage(currentPage + 1);
            }

        }
        else if (isRightSwipe) {
            if (currentPage != 0) {
                gridApi.paginationGoToPage(currentPage - 1);
            }

        }

    }

    const blockUi = (block) => {
        setBlockuiLoading(block)
    }

   var getPageObject = function () {
        var pageNo = gridApi.paginationGetCurrentPage();
        var sortBy = null;
        var order = "asc";
        var filterModel = gridApi.getFilterModel();
        console.debug(filterModel)
        columnGridApi.getColumnState().map((v) => {
            if (v.sort != null) {
                sortBy = v.colId;
                order = v.sort
            }
        });


        var simpleColumnFilters = [];
        Object.keys(filterModel).forEach(k => {
            var obj = {
                column: k,
                filter: filterModel[k].filter,
                dateFrom: filterModel[k].dateFrom,
                dateTo: filterModel[k].dateTo,
                filterType: filterModel[k].filterType,
                searchOperator: filterModel[k].type
            }
            if (obj.column == "seriesNumber") {
                obj.column = "series";
                obj.concatWith = "invoiceNumber";
            }
            simpleColumnFilters.push(obj);
        })


        var object = {
            "quickSearch": fastFilter,
            "pageNo": pageNo,
            "sortBy": sortBy,
            "order": order,
            "pageSize": paginationPageSize,
            "simpleColumnFilters": simpleColumnFilters
        }
        return object;
    }


    const getRowData = (params) => {
        const companyId = useStore.getState().selectedCompany?.id;


        var object = getPageObject();


        ApiClient.getCompanyPreSaleInstancesPage(companyId, object).then(
            response => {

                var saleInstances = response.data.objectList;
                var newSaleInstances = [];
                saleInstances.forEach(element => {
                    var inst = element;
                    inst.seriesNumber = inst.series + inst.invoiceNumber;
                    newSaleInstances.push(inst);
                });

                params.successCallback(newSaleInstances, response.data.totalElements);
                if (newSaleInstances.length == 0) {
                    gridApi.showNoRowsOverlay();
                }
            },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );
    }


    useEffect(() => {

        if (gridApi) {
            const dataSource = {
                getRows: (params) => {
                    let mounted = true;
                    if (mounted) {
                        getRowData(params);
                    }
                    return () => mounted = false;
                }
            }
            let timer1 = setTimeout(function () {
                gridApi.setDatasource(dataSource);
            }, 1000);

            return () => {
                clearTimeout(timer1);
            };

        }
    }, [fastFilter]);


    useEffect(() => {

        if (gridApi) {
            const dataSource = {
                getRows: (params) => {
                    let mounted = true;
                    if (mounted) {
                        getRowData(params);
                    }
                    return () => mounted = false;
                }
            }
            if (i18n.language == "el-GR" || i18n.language == "gr") {
                setAggridLocal(AG_GRID_LOCALE_GR);
            }
            else {
                setAggridLocal(AG_GRID_LOCALE_EN);
            }
            gridApi.setDatasource(dataSource);

        }
    }, [gridApi]);


  
    const onGridReady = params => {
        setGridApi(params.api);
        setColumnGridApi(params.columnApi);
        window.addEventListener('resize', function () {
            setTimeout(function () {
                // params.api.sizeColumnsToFit();
                setSheight(window.innerHeight - 190);
            }, 300);
        });
    };
    const onQuickFilterChanged = e => {
        console.log();
        gridApi.fastFilter = e.target.value;
        // gridApi.setQuickFilter(e.target.value);
        setFastFilter(e.target.value.trim());

    };
    const onClickPrint = data => {
        console.log(data)
        setPrintSale(data)
        iframePrintTemplate.current.print(data)
    }

    const goTo = invoiceUid => {
        navigate("/mydata/" + invoiceUid);
    }
    const onPaginationChanged = (val) => {
        var currentPage = val.api.paginationGetCurrentPage();
        setCurrentPage(currentPage)

    }
    const dateFormatter = (params) => {
        if (params.data?.invoiceDate) {
            return moment(params.data.invoiceDate, 'DD/MM/YYYY HH:mm:ssZZ').format('DD/MM/YYYY HH:mm');
        }
        return "";
    }
    const onChangeContact = data => {
        setSelectedCustomerContacts(data);
    }
    const onInputChangeContact = (contact) => {

    }




    function getContactEmails(sale, sendPaymentLink) {
        var customerName = sale.customeName;
        const company = useStore.getState().selectedCompany;
        var subject = t("emailSubject", { company: company.name });

        var contactEmails = [];
        selectedCustomerContacts.forEach(contact => {
            if (contact.email == undefined || contact.email == null) {
                contact.email = contact.value;
                contact.name = contact.value
            }
            var body = "<p>" + t("emailBody1", { contactName: contact.name }) + "</p>";
            body += "<p>" + t("emailBody2", { company: company.name }) + "</p>";
            var link = "<a href='https://app.timologic.gr/mydata/" + sale.invoiceUid + "'>" + sale.invoiceTypeName + " " + sale.series + sale.invoiceNumber + "</a>";
            body += "<p>" + t("emailBody3", { link: link }) + "</p>";
            // body += "<p>" + t("emailBody4") + "</p>";
            var link2 = "<a href=" + company.vivaQuickPay + "/" + sale.totalPayment + ">" + t("here") + "</a>";
            if (sendPaymentLink && company.vivaQuickPay) {
                body += "<p>" + t("emailBody6", { link: link2 }) + "</p>";
            }
            // body += "<small>" + t("emailBody5") + "</small>";
            contactEmails.push({
                subject: subject,
                body: body,
                email: contact.email
            });
        })
        return contactEmails;

    }
    const getPrintSale = (sale) => {
        const config = {
            nameFromNode: node => node.product.name,
            muFromNode: (node, t) => t(node.measurementUnit),
            whTaxFromNode: node => node.myDataWithHoldTaxes?.amountValue ?? "0.00",
            vatFromNode: node => node.vat.value,
            idFromNode: node => node.id,
            codeFromNode: node => node.productCode,
            logo: sale.logo,
            issuerAddress: sale.branchAddress,
            issuerEmail: sale.issuerEmail,
            issuerPhone: sale.issuerPhone,
            subjectField: sale.issuerSubjectField,
            cancelmark: sale.cancellationMark,
            mark: sale.mark,
            issuerName: sale.company?.name,
            customerName: sale.customerName,
            customerCode: sale.customerCode,
            customerCountry: sale.customerCountry,
        };
        return buildPrintSale(sale, config);
    }
    const onSendEmail = () => {
        var contactEmails = getContactEmails(lineData, sendPaymentLink);
        document.getElementById("template").style.display = "unset";
        const ps = getPrintSale(lineData);

        setPrintSale(ps)
        setTimeout(function () {
            setBlockuiLoading(true)
            try {
                var store = false;
                const user = useStore.getState().loggedInUser;
                if (lineData.myDataInvoiceType == "invoice1_1" || lineData.myDataInvoiceType == "invoice2_1") {
                    store = true;
                }
                iframePrintTemplate.current._sendEmail({ contacts: contactEmails, store: store, taxpayerId: lineData.company.taxpayerId, fromEmail: user.email }, function (resp) {
                    setBlockuiLoading(false)
                    document.getElementById("template").style.display = "none";
                    setShowEmailModal(false);
                    if (resp.data.status == "SUCCESS") {
                        toast.success(t("emailSended"));
                    }
                    else {
                        toast.error(t("emailNotSended"));
                    }
                });
            }
            catch (e) {
                console.error(e)
                setBlockuiLoading(false)
            }
        })

    }
    const exportToExcel = (e) => {
        e.preventDefault();
        const companyId = useStore.getState().selectedCompany?.id;
        setBlockuiLoading(true)
        var object = getPageObject();
        ApiClient.exportCompanySalesToExcel(companyId, object).then(
            response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'export.xlsx');
                document.body.appendChild(link);
                link.click();
                setBlockuiLoading(false)
            },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString());
                setBlockuiLoading(false)
            }
        );
    }

    const getHeaderTemplate = () => {
        return <span><img style={{ width: 60 }} src={MyDataLogo}></img></span>
    }

    return (
        <BlockUi tag="div" blocking={blockuiLoading}>

            <div className="container-fluid" style={{ padding: 0 }}>
                <header className="jumbotron search_header">

                    {/* <div> {t("PreSalesSearchInfo")}<span><a href="/sales">{t("PreSalesSearchInfo2")}</a></span></div> */}


                    <div className="d-flex bd-highlight">

                        <div className="me-auto p-0 bd-highlight">
                            <h5 className="subtitle skin">{t("PreSalesSearchNav")}
                                <Tippy trigger="click" content={t("PreSalesSearchInfo")}>
                                    <i className="fa fa-info-circle" style={{ marginLeft: 6 }}></i>
                                </Tippy>
                            </h5>
                        </div>


                    </div>
                </header>
                <div style={{ width: '100%', height: '100%' }}>
                    <div className="row">
                        <div className="d-flex bd-highlight">
                            <div className="p-1 flex-grow-1 bd-highlight searchSalesInputContainer">
                                <input style={{ maxWidth: 400 }} placeholder={t('Search')} className="form-control" id="searchSalesInput" onChange={onQuickFilterChanged} />
                            </div>
                            <div className="p-1 bd-highlight">


                                <div style={{ position: "absolute", top: 0, right: 0, marginRight: "1%" }}>

                                    <div className="d-flex" style={{ position: "relative" }}>
                                        <div className="p-1 bd-highlight">
                                            <button className="btn btn-skin btn-sm" href="" onClick={function () { return navigate("/sale"); }}>
                                                <span className="desktop-only">{t("PublicationNew")} </span> <i className="fa  fa-plus"></i>
                                            </button>
                                        </div>
                                        <div className="p-1 bd-highlight">
                                            <button className="btn btn-skin btn-sm" title={t("exportToExcel")} onClick={exportToExcel}> <i className="fa fa-file-excel-o"></i></button>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="selectInputContainer">
                                    <Select
                                        className="column-choicer"
                                        styles={sortByStyles }
                                        placeholder={t("sortBy")}
                                        defaultValue={[]}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={(options) => {
                                            if (Array.isArray(options)) {
                                                setSelectedOptions(options.map((opt) => opt.value));
                                            }
                                        }}
                                        options={allOptions}
                                        components={{
                                            Option: InputOption
                                        }}
                                    />
                                </div> */}

                            </div>
                            <div className="p-0 bd-highlight mobile-only">
                                <div className="p-1 bd-highlight mobile-only">
                                    <DateRangePickerInput gridApi={gridApi} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        !isMobile ?
                            <div
                                id="myGrid"
                                style={{ height: '100%', width: '100%' }}
                                className="ag-theme-alpine-dark sales-table-container"
                            >
                                <div className="ag-theme-alpine" style={{ height: sheight, width: '100%' }}>
                                    <AgGridReact
                                        pagination={pagination}
                                        paginationPageSize={paginationPageSize}
                                        onGridReady={onGridReady}
                                        // domLayout={'autoHeight'}
                                        style={{ width: '100%', height: '100%' }}
                                        // onRowDoubleClicked={(e) => goTo(e.data.invoiceUid)}
                                        // rowData={content}
                                        // domLayout={'autoHeight'}
                                        animateRows={true}

                                        suppressRowTransform={true}
                                        frameworkComponents={{
                                            agDateInput: CustomDateComponent
                                        }}
                                        overlayNoRowsTemplate={
                                            '<span style="padding: 10px;  color:#013289">' + t('noEntries') + '</span>'
                                        }
                                        onPaginationChanged={onPaginationChanged}
                                        rowModelType={'infinite'}
                                        cacheBlockSize={paginationPageSize}
                                        localeText={aggridLocal}
                                        gridOptions={{ suppressMenuHide: true }}
                                        defaultColDef={{
                                            flex: 1,
                                            resizable: true,
                                            sortable: true,
                                            wrapText: true,
                                            suppressMovable: true,
                                            autoHeight: true,
                                            icons: {
                                                menu: '<i style="color:white" class="fa fa-search"/>',
                                            },
                                        }}
                                        columnDefs={[
                                            {
                                                field: "seriesNumber", flex: 2, minWidth: 120, headerName: t("Number"), cellRenderer: SeriesNumberRendener, sortable: true, filter: "agTextColumnFilter",
                                                cellRendererParams: {
                                                    printSale: printSale,
                                                    onClickPrint: onClickPrint,
                                                    blockUi: blockUi,
                                                    setShowEmailModal: setShowEmailModal,
                                                    setCustomerContacts: setCustomerContacts,
                                                    setLineData: setLineData,
                                                    getPrintSale: getPrintSale,
                                                    setTemplate: setTemplate
                                                }
                                            },
                                            { field: "invoiceTypeName", flex: 5, minWidth: 220, headerName: t("InvoiceType"), sortable: true, filter: "agTextColumnFilter" },
                                            { field: "invoiceDate", minWidth: 140, valueFormatter: dateFormatter, flex: 2, headerName: t('IssueDate'), sortable: true, filter: "agDateColumnFilter", filterParams: { buttons: ['reset', 'apply'], inRangeInclusive: true } },
                                            { field: "customerName", flex: 5, minWidth: 250, headerName: t("Customer"), sortable: true, filter: "agTextColumnFilter" },
                                            { field: "customerTaxPayerId", flex: 2, minWidth: 150, headerName: t("taxpayerId"), sortable: true, filter: "agTextColumnFilter" },
                                            { field: "totalWithoutVat", minWidth: 100, valueFormatter: params => params.data != null ? params.data.totalWithoutVat.toFixed(2) : 0.00, flex: 2, headerName: t("TotalWithoutVat"), sortable: true, filter: "agNumberColumnFilter" },
                                            { field: "totalWithVat", minWidth: 100, valueFormatter: params => params.data != null ? params.data.totalWithVat.toFixed(2) : 0.00, flex: 2, headerName: t("TotalWithVat"), sortable: true, filter: "agNumberColumnFilter" },
                                            {
                                                field: "action", flex: 1, minWidth: 100, headerName: t("Actions"), cellRenderer: PresalesActionRenderer,
                                                cellRendererParams: {
                                                    printSale: printSale,
                                                    onClickPrint: onClickPrint,
                                                    blockUi: blockUi,
                                                    setShowEmailModal: setShowEmailModal,
                                                    setCustomerContacts: setCustomerContacts,
                                                    setLineData: setLineData,
                                                    getPrintSale: getPrintSale,
                                                    setTemplate: setTemplate
                                                }
                                            }
                                        ]}
                                    >
                                    </AgGridReact>
                                </div>
                                <IFramePrintTemplate template={template} ref={iframePrintTemplate} ></IFramePrintTemplate>
                            </div> :



                            <div
                                id="myGrid"
                                onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}
                                style={{ height: '100%', width: '100%' }}
                                className="ag-theme-alpine-dark sales-mobile-table-container"
                            >
                                <div className="ag-theme-alpine" style={{ height: sheight, width: '100%' }}>
                                    <AgGridReact
                                        pagination={pagination}
                                        paginationPageSize={paginationPageSize}
                                        onGridReady={onGridReady}
                                        // domLayout={'autoHeight'}
                                        style={{ width: '100%', height: '100%' }}
                                        // onRowDoubleClicked={(e) => goTo(e.data.invoiceUid)}
                                        // rowData={content}
                                        // domLayout={'autoHeight'}
                                        animateRows={true}
                                        suppressCellSelection={true}
                                        suppressRowTransform={true}
                                        overlayNoRowsTemplate={
                                            '<span style="padding: 10px;  color:#013289">' + t('noEntries') + '</span>'
                                        }
                                        overlayLoadingTemplate={
                                            '<span className="ag-overlay-loading-center"><img src="loading.gif">' + t('aggridPageLoadMess') + '</span>'
                                        }
                                        rowHeight={86}
                                        onPaginationChanged={onPaginationChanged}
                                        rowModelType={'infinite'}
                                        cacheBlockSize={paginationPageSize}
                                        gridOptions={{ suppressMenuHide: true }}
                                        tooltipHideDelay={0}
                                        enableBrowserTooltips={false}
                                        localeText={aggridLocal}
                                        defaultColDef={{
                                            sortable: true,
                                            wrapText: false,
                                            suppressHorizontalScroll: true,
                                            suppressMovable: true,
                                        }}
                                        columnDefs={[
                                            { field: "id", sort: "desc", hide: true },
                                            { field: "invoiceTypeName", flex: 5, headerName: t(""), sortable: true, cellRenderer: AllFieldsRenderer, tooltipField: "invoiceTypeName" },
                                            { field: "invoiceDate", hide: true, valueFormatter: dateFormatter, headerName: t('DateTime'), sortable: true, filter: "agDateColumnFilter", filterParams: { inRangeInclusive: true } },
                                            {
                                                field: "action", flex: 0.5, headerName: t(""), cellRenderer: PresalesActionRenderer,
                                                cellRendererParams: {
                                                    printSale: printSale,
                                                    onClickPrint: onClickPrint,
                                                    blockUi: blockUi,
                                                    setShowEmailModal: setShowEmailModal,
                                                    setCustomerContacts: setCustomerContacts,
                                                    setLineData: setLineData,
                                                    getPrintSale: getPrintSale,
                                                    setTemplate: setTemplate
                                                }
                                            }
                                        ]}
                                    >
                                    </AgGridReact>
                                </div>
                                <IFramePrintTemplate style={{ width: 800, height: "297mm", left: 0, top: 0, position: "fixed", zIndex: -100 }} extracss={template.css} template={template} ref={iframePrintTemplate} ></IFramePrintTemplate>

                            </div>

                    }
                </div>
            </div>
            <Modal
                aria-labelledby="contained-modal-title-vcenter"

                centered
                show={showEmailModal}
                dialogClassName="email-modal"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header >
                    <Modal.Title>{t("sendEmail")}</Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    <span className="totalConstraintInfo"></span>
                    <div className="row">
                        <div className="col-md-12 selectInputContainer form-group">
                            <label className="control-label inputlabel">{t("customerContacts")}
                                <i data-tip data-for="ccInfo" className="fa fa-x2 fa-info-circle infoicon" data-bs-toggle="tooltip" data-bs-placement="top"></i>
                                <Tippy trigger="click" content={t("ccInfo2")}>
                                    <i className="fa fa-x2 fa-info-circle infoicon"></i>
                                </Tippy>
                            </label>

                            <Controller
                                render={({ field }) => (
                                    <SelectTable {...field}
                                        inputId="contacts-react-select"
                                        onChange={onChangeContact}
                                        onChangeValue={onChangeContact}
                                        onInputChange={onInputChangeContact}
                                        isMulti={true}
                                        options={customerContacts}
                                        createTable={true}
                                        className={`form-control ${errors.customerContact ? 'is-invalid' : ''}`}
                                        placeholder={t('Select')}
                                        width={500}
                                    >

                                    </SelectTable>
                                )}
                                control={control}
                                name="customerContacts"
                                defaultValue=""
                            />
                            <br></br>
                            <input type="checkbox" onChange={e => setSendPaymentLink(e.target.checked)} name="sendPaymentLink" checked={sendPaymentLink} className="form-check-input" />{t("Send Payment link")}

                            <div className="invalid-feedback">{errors.customerContact?.message}</div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-skin" onClick={function () { setShowEmailModal(false) }}>{t("cancel")}</button>
                    <button id="onExtras" className="btn btn-skin" onClick={onSendEmail}>{t("send")}</button>
                </Modal.Footer>
            </Modal>


        </BlockUi>
    );
}


